import { Box, CircularProgress, styled } from "@mui/material";
import HeroImage from "../assets/img/vessel_sunset.jpg";

const SplashBox = styled(Box)`
	background-image: url(${HeroImage});
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	height: 100vh;
	background-size: cover;
	background-position: center;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 9999;

	.MuiCircularProgress-root {
		color: white;
	}
`;

function SplashLoading() {
	return (
		<SplashBox data-testid="splash-loading">
			<CircularProgress />
		</SplashBox>
	);
}

export default SplashLoading;
